module.exports = __webpack_public_path__ + "img/none-module.e18347b4.svg";